import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import '@/assets/css/css.css'
import App from './App.vue'
import router from './router'
import './plugins/element.js'
import VueAnimateNumber from 'vue-animate-number'
import 'animate.css'
import 'default-passive-events'
import store from './store'
import apiFun from './request/api'
import preventReClick from './assets/js/preventRepeatClick'
import { WOW } from 'wowjs'
import axios from 'axios'

Vue.use(ElementUI)
Vue.use(preventReClick)
Vue.prototype.$apiFun = apiFun
Vue.use(VueAnimateNumber)
Vue.prototype.$bus = new Vue()

// 修复 WOW.js 动画
Vue.prototype.$wow = new WOW({ live: false })
Vue.prototype.$wow.init()

Vue.config.productionTip = false

// 跨标签页 session 同步
Vue.prototype.setSessionItem = function (key, newVal) {
  sessionStorage.setItem(key, newVal)
  const event = new StorageEvent('storage', {
    key, newValue: newVal, storageArea: sessionStorage
  })
  window.dispatchEvent(event)
}

// ======================================
// 百度广告 bd_vid 捕获+自动提交后端逻辑
// ======================================

/**
 * 提交bd_vid到后端接口
 * @param {string} bdVid 捕获到的百度点击ID
 */
async function submitBdVidToBackend(bdVid) {
  // 防止重复上报：同一个bd_vid只提交一次
  const reportedBdVid = localStorage.getItem('baidu_bd_vid_reported')
  if (reportedBdVid === bdVid) {
    console.log('ℹ️ 该bd_vid已提交过后端，跳过重复上报')
    return
  }

  try {
    // 调用你的后端接口，传递bd_vid
    // const res = await axios.post('https://api.7daili.com/api/adb/index', {
    //   bd_vid: bdVid,
    //   action: 'save_bd_vid' // 标记是保存bd_vid的请求，方便后端区分
    // })

    // 上报成功，标记已提交
    localStorage.setItem('baidu_bd_vid_reported', bdVid)
    console.log('✅ bd_vid已成功提交后端:', bdVid)
    console.log('后端返回:', res.data)

  } catch (error) {
    console.error('❌ bd_vid提交后端失败:', error.message)
    // 失败重试：3秒后再试一次
    setTimeout(() => {
      console.log('🔄 重试提交bd_vid到后端...')
      submitBdVidToBackend(bdVid)
    }, 3000)
  }
}

/**
 * 核心捕获函数（兼容History/Hash路由）
 */
function captureBdVid() {
  let bdVid = null

  // 1. 从URL搜索参数获取（History模式）
  const urlParams = new URLSearchParams(window.location.search)
  bdVid = urlParams.get('bd_vid')

  // 2. 从Hash中获取（Hash模式）
  if (!bdVid && window.location.hash) {
    const hashQuery = window.location.hash.split('?')[1] || ''
    const hashParams = new URLSearchParams(hashQuery)
    bdVid = hashParams.get('bd_vid')
  }

  // 3. 捕获成功：保存+自动提交后端
  if (bdVid && bdVid.trim() !== '') {
    bdVid = bdVid.trim()
    // 保存到localStorage（备用）
    localStorage.setItem('baidu_bd_vid', bdVid)
    localStorage.setItem('baidu_bd_vid_expire', Date.now() + 30 * 24 * 60 * 60 * 1000)
    
    console.log('✅ 百度广告bd_vid捕获成功:', bdVid)
    // 立即异步提交到后端
    submitBdVidToBackend(bdVid)
  } else {
    console.log('ℹ️ 未检测到百度广告bd_vid参数')
  }
}

/**
 * 全局清除bd_vid方法（注册成功后调用）
 */
Vue.prototype.$clearBdVid = function() {
  localStorage.removeItem('baidu_bd_vid')
  localStorage.removeItem('baidu_bd_vid_expire')
  localStorage.removeItem('baidu_bd_vid_reported')
  console.log('🗑️ 百度bd_vid已全部清除')
}

// 页面首次加载完成后立即捕获
document.addEventListener('DOMContentLoaded', () => {
  captureBdVid()
})

// ======================================
// 路由守卫（保留登录验证+bd_vid续期）
// ======================================
router.beforeEach((to, from, next) => {
  // bd_vid自动续期+过期清除
  const bdVid = localStorage.getItem('baidu_bd_vid')
  const expireTime = localStorage.getItem('baidu_bd_vid_expire')
  if (bdVid && expireTime && Date.now() < parseInt(expireTime)) {
    localStorage.setItem('baidu_bd_vid_expire', Date.now() + 30 * 24 * 60 * 60 * 1000)
  } else if (expireTime && Date.now() >= parseInt(expireTime)) {
    Vue.prototype.$clearBdVid()
  }

  // 原有登录验证逻辑
  const token = sessionStorage.getItem('token')
  if (to.meta && to.meta.requireAuth) {
    if (token) next()
    else {
      Vue.prototype.$message.warning('请先登录！')
      next('/')
    }
  } else {
    next()
  }
})

new Vue({
  router, store, render: h => h(App)
}).$mount('#app')